export default __webpack_public_path__ + "static/flaviomachado-b811c9354ae284b660ffd731b6e0d180.webp";